import _ from 'underscore';

const i18nKey2value = {
  /* submenu options */
  MenuSales: _TL_('Sales categories'),
  Purchase: _TL_('Purchase'),
  AddToCart: _TL_('Add to cart'),
  BeginCheckout: _TL_('Begin checkout'),
  Subcribe: _TL_('Subscribe'),
  MenuLeads: _TL_('Leads categories'),
  SubmitLeadForm: _TL_('Submit lead form'),
  BookAppointment: _TL_('Book appointment'),
  Signup: _TL_('Sign - up'),
  RequestQuote: _TL_('Request quote'),
  GetDirections: _TL_('Get directions'),
  OutboundClick: _TL_('Outbound click'),
  MenuFurther: _TL_('Other categories'),
  Contact: _TL_('Contact'),
  PageView: _TL_('Page view'),
  Other: _TL_('Other'),
  Download: _TL_('Download'),
  InStoreVisit: _TL_('Store visit'),
  /* goal settings */
  Event_Goal_Settings_Custom_Event: _TL_('Custom event parameters'),
  Learn_More: _TL_('Learn more'),
  Event_Goal_Settings_Event_Param_Instruction: _TL_('Select the parameters you\'d like to send with your event. The parameters shown below are just an example. You can change or add parameters you\'d like to send with your event. You can also use variables to send dynamic data.'),
  /* finish step */
  ApplicationInstallGoal: _TL_('mobile app install goal'),
  InStoreTransactionGoal: _TL_('instore transaction goal'),
  InStoreVisitGoal: _TL_('Store visits goal'),
};

export const getSubmenuCalloutOptions = i18n => ({
  /* submenu callout options */
  Purchase: { title: i18n.getString(_TL_('Purchase')), description: i18n.getString(_TL_('The completion of an order, usually signified by receiving an order/purchase confirmation. ')) },
  AddToCart: { title: i18n.getString(_TL_('Add to cart')), description: i18n.getString(_TL_('The addition of an item to the shopping cart(such as selecting the Add to cart button on the website).')) },
  BeginCheckout: { title: i18n.getString(_TL_('Begin checkout')), description: i18n.getString(_TL_('The start of the checkout process. ')) },
  Subcribe: { title: i18n.getString(_TL_('Subscribe')), description: i18n.getString(_TL_('The start of a paid subscription to a product or service you offer. ')) },
  SubmitLeadForm: { title: i18n.getString(_TL_('Submit lead form')), description: i18n.getString(_TL_('The submission of information by a potential customer for a product or service you offer. ')) },
  BookAppointment: { title: i18n.getString(_TL_('Book appointment')), description: i18n.getString(_TL_('The booking of an appointment with your business.')) },
  Signup: { title: i18n.getString(_TL_('Sign - up')), description: i18n.getString(_TL_('The completion of a form to sign up for a service you offer (such as a newsletter).')) },
  RequestQuote: { title: i18n.getString(_TL_('Request quote')), description: i18n.getString(_TL_('The request from a customer to get more details of the product or service you offer, along with pricing information.')) },
  GetDirections: { title: i18n.getString(_TL_('Get directions')), description: i18n.getString(_TL_('When a person wants to find one of your locations with the intention of visiting. ')) },
  OutboundClick: { title: i18n.getString(_TL_('Outbound click')), description: i18n.getString(_TL_('When a customer is redirected to an external website.')) },
  Contact: { title: i18n.getString(_TL_('Contact')), description: i18n.getString(_TL_('When a customer contacts your business via telephone/SMS, email, chat, or any other type of contact.')) },
  PageView: { title: i18n.getString(_TL_('Page view')), description: i18n.getString(_TL_('A visit to a webpage that you have identified as being important to your business, such as a product page or search results. ')) },
  Other: { title: i18n.getString(_TL_('Other')), description: i18n.getString(_TL_('Use this if the other categories don’t match the actions you are tracking as a conversion.')) },
  Download: { title: i18n.getString(_TL_('Download')), description: i18n.getString(_TL_('Download')) },
  InStoreVisit: { title: i18n.getString(_TL_('Store visit')), description: i18n.getString(_TL_('When a customer visits one of your store locations.')) },
});

export const eventTrackingMethods = {
  InlineAction: { key: 'InlineAction', text: _TL_('Track event on inline action.'), ariaLabel: _TL_('Track event on inline action.') },
  PageLoad: { key: 'PageLoad', text: _TL_('Track event on page load.'), ariaLabel: _TL_('Track event on page load.') },
};

export const eventTagSetupTemplates = {
  [eventTrackingMethods.InlineAction.key]: 'InlineEventSnippet',
  [eventTrackingMethods.PageLoad.key]: 'PageLoadEventSnippet',
};

export const tagSetupExampleTemplates = {
  [eventTrackingMethods.InlineAction.key]: 'InlineActionEventTagExample',
  [eventTrackingMethods.PageLoad.key]: 'PageLoadEventTagExample',
  UET: 'UETExample',
};

const goalTypeContents = [
  {
    id: 'DestinationGoal',
    title: _TL_('Destination URL'),
    description: _TL_('Track every time someone visits a web page as a conversion.'),
    iconName: 'Link',
  },
  {
    id: 'DurationGoal',
    title: _TL_('Duration'),
    description: _TL_('Track every time someone stays on a website for longer than a certain amount of time as a conversion.'),
    iconName: 'Clock',
  },
  {
    id: 'EventGoal',
    title: _TL_('Event'),
    description: _TL_('Track every time someone completes a specific action such as, subscribing to newsletter or downloading whitepaper, as a conversion.'),
    glyphIconName: 'ba-Click',
  },
  {
    id: 'PageViewsPerVisitGoal',
    title: _TL_('Pages viewed per visit'),
    description: _TL_('Track every time someone visits more than a specified number of pages on your website as a conversion.'),
    glyphIconName: 'ba-AdUnitChannel',
  },
  {
    id: 'ApplicationInstallGoal',
    title: _TL_('Mobile app install'),
    description: _TL_('Track every time someone installs your app as a conversion.'),
    iconName: 'CellPhone',
  },
  {
    id: 'ProductConversionGoal',
    title: _TL_('Product'),
    description: _TL_('Track product purchases back to the ads that led to them.'),
    iconName: 'Product',
  },
  {
    id: 'InStoreTransactionGoal',
    title: _TL_('In-store transaction'),
    description: _TL_('Add in-store transaction conversions to Microsoft Advertising.'),
    iconName: 'Shop',
  },
  {
    id: 'OfflineConversionGoal',
    title: _TL_('Offline conversions'),
    description: _TL_('Add offline conversions to Microsoft Advertising.'),
    iconName: 'Upload',
  },
  {
    id: 'InStoreVisitGoal',
    title: _TL_('Store visits'),
    description: _TL_('Add Store visit conversions to Microsoft Advertising.'),
    glyphIconName: 'ba-PedometerSteps',
  },
];

const stepTitles = {
  create: {
    DestinationGoal: _TL_('Create a destination goal'),
    DurationGoal: _TL_('Create a duration goal'),
    EventGoal: _TL_('Create an event goal'),
    PageViewsPerVisitGoal: _TL_('Create a page view goal'),
    ApplicationInstallGoal: _TL_('Create a mobile app install goal'),
    ProductConversionGoal: _TL_('Create a product conversion goal'),
    InStoreTransactionGoal: _TL_('Create an instore transaction goal'),
    InStoreVisitGoal: _TL_('Create an Store visits goal'),
    OfflineConversionGoal: _TL_('Create an offline conversion goal'),
  },
  edit: {
    DestinationGoal: _TL_('Edit destination goal'),
    DurationGoal: _TL_('Edit duration goal'),
    EventGoal: _TL_('Edit event goal'),
    PageViewsPerVisitGoal: _TL_('Edit page view goal'),
    ApplicationInstallGoal: _TL_('Edit mobile app install goal'),
    ProductConversionGoal: _TL_('Edit product conversion goal'),
    InStoreTransactionGoal: _TL_('Edit instore transaction goal'),
    InStoreVisitGoal: _TL_('Edit Store visits goal'),
    OfflineConversionGoal: _TL_('Edit offline conversion goal'),
    ClarityEventGoal: _TL_('Create an event goal'),
  },
};

export const cali18n = key => (i18nKey2value[key]);

export const getTitleByGoalType = (isEdit, goalType) => (isEdit ? stepTitles.edit[goalType] : stepTitles.create[goalType]);

const disallowedEditGoals = ['ProductConversionGoal', 'InStoreTransactionGoal', 'OfflineConversionGoal', 'InStoreVisitGoal'];

// currentGoalType only exists in edit scenario. disallowedEditGoals should be mutual exclusive on isDisabled against other types.
export const getGoalTypeContents = (availableTypes, i18n, isEditScenario, currentGoalType) => {
  const contents = [];
  const isOriginalDisallowedEdit = disallowedEditGoals.indexOf(currentGoalType) > -1;
  _.each(goalTypeContents, (content) => {
    if (availableTypes.indexOf(content.id) > -1) {
      const isDisallowedEditGoal = disallowedEditGoals.indexOf(content.id) > -1;
      contents.push(Object.assign({}, content, {
        title: i18n.getString(content.title),
        description: i18n.getString(content.description),
        isDisabled: isEditScenario && ((!isOriginalDisallowedEdit && isDisallowedEditGoal) || (isOriginalDisallowedEdit && content.id !== currentGoalType)),
      }));
    }
  });
  return contents;
};

export const isUetBasedGoal = (goal) => {
  switch (goal.Type) {
    case 'DestinationGoal':
    case 'DurationGoal':
    case 'PageViewsPerVisitGoal':
    case 'EventGoal':
    case 'ProductConversionGoal':
    case 'SmartGoal':
    case 'ClarityEventGoal':
      return true;
    default:
      return false;
  }
};

export const isTypeIncluedForEnhancedConversions = ({ goalType, goalValueType }) => {
  const varientValue = goalValueType === 'VariantValue';
  const IncludedGoalTypes = ['EventGoal', 'DestinationGoal', 'DurationGoal', 'PageViewsPerVisitGoal', 'OfflineConversionGoal'];
  return IncludedGoalTypes.includes(goalType) || varientValue;
};
